import React from 'react';

const HeaderLoader = () => (
    <div className='h-5 w-5 inline-block ml-4 animate-spin rounded-full border-4 border-current border-r-transparent'></div>
);

export default HeaderLoader;
